import i18next from 'i18next';
import { printValue } from 'yup';

function getFieldName(path) {
    return i18next.exists(path) ? i18next.t(path) : 'Dette feltet';
}

export default {
    mixed: {
        default: ({ path }) => `${getFieldName(path)} er ugyldig`,
        required: ({ path }) => `${getFieldName(path)} er et obligatorisk felt`,
        defined: ({ path }) => `${getFieldName(path)} må være definert`,
        notNull: ({ path }) => `${getFieldName(path)} kan ikke være null`,
        oneOf: ({ path, values }) =>
            `${getFieldName(path)} må være en av følgende verdier: ${i18next.t(values)}`,
        notOneOf: ({ path, values }) =>
            `${getFieldName(path)} må ikke være en av følgende verdier: ${i18next.t(values)}`,
        notType: ({ path, type, value, originalValue }) => {
            const isCast = originalValue != null && originalValue !== value;
            let msg =
                `${getFieldName(path)} må være en \`${i18next.t(type)}\` type, ` +
                `men den endelige verdien var: \`${printValue(value, true)}\`` +
                (isCast
                    ? ` (konvertert fra verdien \`${printValue(originalValue, true)}\`).`
                    : '.');

            if (value === null) {
                msg +=
                    `\n Hvis "null" er ment som en tom verdi, må du markere skjemaet som` +
                    ' `.nullable()`';
            }

            return msg;
        },
    },
    string: {
        length: ({ path, length }) => `${getFieldName(path)} må være nøyaktig ${length} tegn`,
        min: ({ path, min }) => `${getFieldName(path)} må være minst ${min} tegn`,
        max: ({ path, max }) => `${getFieldName(path)} må være maks ${max} tegn`,
        matches: ({ path, regex }) => `${getFieldName(path)} må samsvare med følgende: "${regex}"`,
        email: ({ path }) => `${getFieldName(path)} må være en gyldig e-postadresse`,
        url: ({ path }) => `${getFieldName(path)} må være en gyldig URL`,
        uuid: ({ path }) => `${getFieldName(path)} må være en gyldig UUID`,
        trim: ({ path }) => `${getFieldName(path)} må være en trimmet streng`,
        lowercase: ({ path }) => `${getFieldName(path)} må være en streng med små bokstaver`,
        uppercase: ({ path }) => `${getFieldName(path)} må være en streng med store bokstaver`,
    },
    number: {
        min: ({ path, min }) => `${getFieldName(path)} må være større enn eller lik ${min}`,
        max: ({ path, max }) => `${getFieldName(path)} må være mindre enn eller lik ${max}`,
        lessThan: ({ path, less }) => `${getFieldName(path)} må være mindre enn ${less}`,
        moreThan: ({ path, more }) => `${getFieldName(path)} må være større enn ${more}`,
        positive: ({ path }) => `${getFieldName(path)} må være et positivt tall`,
        negative: ({ path }) => `${getFieldName(path)} må være et negativt tall`,
        integer: ({ path }) => `${getFieldName(path)} må være et heltall`,
    },
    date: {
        min: ({ path, min }) => `${getFieldName(path)} felt må være senere enn ${min}`,
        max: ({ path, max }) => `${getFieldName(path)} felt må være tidligere enn ${max}`,
    },
    object: {
        noUnknown: ({ path, unknown }) =>
            `${getFieldName(path)} felt har uspesifiserte nøkler: ${i18next.t(unknown)}`,
    },
    array: {
        min: ({ path, min }) => `${getFieldName(path)} felt må ha minst ${min} elementer`,
        max: ({ path, max }) => `${getFieldName(path)} felt må ha maks ${max} elementer`,
        length: ({ path, length }) => `${getFieldName(path)} må ha ${length} elementer`,
    },
    boolean: {
        isValue: ({ path, value }) => `${getFieldName(path)} felt må være ${i18next.t(value)}`,
    },
};
